import dynamic from 'next/dynamic';
export default dynamic(() => import(/* webpackChunkName:"Header" */ './Header').then((mod) => mod.default));
